import "./Footer.css";
import locationIcon from "./assets/images/location.svg";
import mailIcon from "./assets/images/mail.svg";
import callIcon from "./assets/images/call.svg";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-top">

        <div className="footer-left">
          <h3>Seventh August IT Services Private Ltd.</h3>

          <p>
          Seventh August IT Services Private Ltd. is a wholly owned
          subsidiary of{" "}
          <a
            href="https://www.nihilent.com"
            target="_blank"
            rel="noopener noreferrer"
            className="highlight"
          >
            Nihilent Ltd.
          </a>
          , a global IT Consulting and Solutions company.
        </p>
        </div>

        <div className="footer-right">
          <h3>Get in Touch</h3>

          <p className="footer-contact">
            <img
              src={locationIcon}
              alt="Location"
              className="footer-icon"
            />

            <span>
              4th floor, 'D' Block, Weikfield IT Citi Info Park,
              Nagar Road, Sakore Nagar, Viman Nagar,
              Pune, Maharashtra 411014
            </span>
          </p>

          <div className="contact-row">
            <a
              href="mailto:support@artoreal.com"
              className="footer-email"
            >
              <img
                src={mailIcon}
                alt="Mail"
                className="footer-icon"
              />
              support@artoreal.com
            </a>

            <span className="footer-phone">
              <a
              href="tel:+918956528858"
              className="footer-email"
            >
              <img
                src={callIcon}
                alt="Call"
                className="footer-icon"
              />
              +91 8956528858
              </a>
            </span>
          </div>
        </div>

      </div>

      <div className="footer-divider"></div>

      <div className="footer-bottom">
        © 2024 Seventh August IT Services Private Limited.
        {" "}All rights reserved. A subsidiary of
        {" "}
          <a
            href="https://www.nihilent.com"
            target="_blank"
            rel="noopener noreferrer"
            className="highlight"
          >
            <strong>Nihilent Ltd.</strong>
          </a>
      </div>

    </footer>
  );
}

export default Footer;